const mapSocialAccounts = (socialAccounts, booth) => {
  if (!socialAccounts || socialAccounts.length === 0) return []

  return socialAccounts
    .map((account) => {
      const urlOrHandle = account.urlOrHandle?.trim() || ''
      if (!urlOrHandle) return null
      const handle = urlOrHandle.split('/').pop() || urlOrHandle
      switch (account.platform) {
        case 'twitter':
        case 'x':
          return `https://x.com/${handle}`
        case 'facebook':
          return `https://www.facebook.com/${handle}`
        case 'instagram':
          return `https://www.instagram.com/${handle}`
        case 'youtube': {
          const formattedHandle = handle.startsWith('@') ? handle : `@${handle}`
          return `https://www.youtube.com/${formattedHandle}`
        }
        case 'linkedin':
          return `https://www.linkedin.com/${booth ? 'company' : 'in'}/${handle}`
        case 'website':
          return urlOrHandle
        default:
          return urlOrHandle
      }
    })
    .filter(Boolean)
}

export default mapSocialAccounts
